<p-dialog
  [header]="headerKey | abpLocalization"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '26rem', maxWidth: '90vw' }"
  (onHide)="onHide()">
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="mb-3">
      <label for="wrapUpName" class="form-label text-uppercase fw-semibold small mb-1">
        {{ 'Settings::WorkEnvironment:WrapupCodes:Name' | abpLocalization }}
      </label>
      <input
        id="wrapUpName"
        [cxPendingLoader]="!isPredefined && isValidating"
        type="text"
        pInputText
        class="form-control w-100"
        maxlength="100"
        formControlName="name"
        [placeholder]="'Settings::WorkEnvironment:WrapupCodes:NamePlaceholder' | abpLocalization" />
    </div>

    <div class="mb-3">
      <label
        for="wrapUpPolicy"
        class="form-label text-uppercase fw-semibold small mb-1 indicates-required-field">
        {{ 'Settings::WorkEnvironment:WrapupCodes:Policy' | abpLocalization }}
      </label>
      <cx-select
        class="w-100"
        formControlName="policy"
        [options]="policyOptions"
        optionLabel="label"
        optionValue="value"
        [placeholder]="
          'Settings::WorkEnvironment:WrapupCodes:PolicyPlaceholder' | abpLocalization
        "></cx-select>
    </div>

    <div class="mb-3">
      <label for="assignedQueues" class="form-label text-uppercase fw-semibold small mb-1">
        {{ 'Settings::Queues:TabTitle' | abpLocalization }}
      </label>
      <p-multiSelect
        id="assignedQueues"
        formControlName="queueIds"
        [options]="availableQueues"
        optionLabel="name"
        optionValue="id"
        [loading]="queuesLoading"
        [showToggleAll]="true"
        [maxSelectedLabels]="0"
        appendTo="body"
        class="w-100"
        [placeholder]="'Queue::SelectPlaceholder' | abpLocalization">
      </p-multiSelect>
    </div>
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'::Save' | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isBusy"
      [isSubmitting]="isBusy"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
